<script>
import { VForm } from 'vuetify/lib';
export default VForm;
</script>
